<template>
	<div class="partner_list">
		<!-- 表格 -->
		<el-table v-loading="loading" :data="tableData" style="width: 100%;min-height: 76vh;">
			<el-table-column label="合伙人" width="250" show-overflow-tooltip align="left">
				<template slot-scope="scope">
					<div class="hhrtx"><img :src='scope.row.partner_headimg' class="hhrimg" /></div>
					<span class="hhrname">{{scope.row.partner_nick}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="partner_oauth" label="经营者" align="center">
				<template slot-scope="scope">
					{{scope.row.partner_oauth?scope.row.partner_oauth:'--'}}
				</template>
			</el-table-column>
			<el-table-column prop="group_name" label="所在社群" width="250" align="center">
			</el-table-column>
			<el-table-column prop="level_name"  width="150" label="合伙人等级" align="center">
				<template slot-scope="scope">
					<div class="level_name" @click="editLevel(scope.row.id,scope.row.level)">
						<p>{{scope.row.level_name}}</p>
						<i class="el-icon-edit-outline"></i>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="sales_product" label="分销商品" align="center">
			</el-table-column>
			<el-table-column prop="total_commission" label="累计佣金" align="center">
			</el-table-column>
			<el-table-column prop="stay_commission" label="待结算佣金" align="center">
			</el-table-column>
			<el-table-column prop="save" label="操作" width="80px" fixed="right" align="center">
				<template slot-scope="scope">
					<el-button type="text" size="medium" @click="goDetail(scope.row.id)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog width="400px" title="合伙人等级调整" :visible.sync="show_level" :before-close='close_dialog'  :close-on-click-modal='false'>
		  <el-form :model="form" style="padding-left: 20px;margin-top: 10px;">
			  <el-select v-model="level" id="hundred_id" placeholder="默认同城配送" style="width: 300px;">
			     <el-option
			          v-for="item in level_arr"
			          :key="item.value"
			          :label="item.label"
			          :value="item.value"
			  									>
			        </el-option>
			  </el-select>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
			<el-button @click="close_dialog">取 消</el-button>
			<el-button type="primary" @click="saveLevel()">确 定</el-button>
		  </div>
		</el-dialog>
		<!-- 分页器 -->
		<div class="block" style="padding: 40px;background: #ffffff;">
			<el-pagination background align='center' @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
				layout="total, prev, pager, next, jumper" :pager-count='5' :total="total">
			</el-pagination>
		</div>
	</div>

</template>

<script>
	import {
		getPartnerData,
		changeLevel
	} from '../../api/partner';
	export default {
		data() {
			return {
				level_arr:[
					{
						value:1,
						label:'普通合伙人'
					},
					{
						value:2,
						label:'专属合伙人'
					}
				],
				show_level:false,
				level:1,
				id:0,
				
				tableData: [], //列表数据
				currentPage: 0, // 当前页码
				total: 0, // 总条数
				pageSize: 10, // 每页的数据条数
				loading: true
			};
		},
		created() {
			this.currentPage = 0;
			this.getList();
		},
		methods: {
			close_dialog(){
				this.show_level = false;
			},
			editLevel(id,level){
				this.id = id;
				this.level = level;
				this.show_level = true;
			},
			goDetail(id) {
				this.$router.push({
					path: '/customer/partner-detail',
					query: {
						id: id,
					}
				});
			},
			saveLevel(){
				var id = this.id;
				var level = this.level;
				changeLevel({
					id:id,
					level:level
				}).then(res=>{
					if(res.code==0){
						this.$message.success(res.message);
						this.show_level = false;
						this.id = 0;
						this.getList();
					}else{
						this.$message.error(res.message);
					}
				})
			},
			getList() {
				this.loading = true;
				let currentPage = this.currentPage;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				getPartnerData({
					'start': currentPage * 10
				}).then(res => {
					if (res.code == 0) {
						this.total = res.data.count;
						this.loading = false;
						this.tableData = res.data.list;
					} else {
						this.$message.error(res.message);
					}

				})
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			}
		}
	};
</script>

<style scoped>
	.father-main {
		overflow: auto;
	}

	.partner_list {
		min-height: 88vh;
	}

	.el-pagination.is-background .el-pager li {
		background: none;
	}

	.el-pagination.is-background .btn-next,
	.el-pagination.is-background .btn-prev {
		background: none;
	}

	.el-table th {
		text-align: center;
	}

	.hhrtx {
		display: inline-block;
		vertical-align: middle;
		padding: 0 15px;
	}

	.hhrimg {
		width: 40px;
		height: 40px;
		object-fit: cover;
		border-radius: 40px;
	}

	.hhrname {
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}
	.level_name{
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
</style>
